module.exports = __webpack_public_path__ + "static/media/create_video@2x.5abe2549.png";